import { Tag, Text } from 'shell/components';

const TagDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Tag</Text>
            <Tag type={'ai'} value={'feedback'} />
            <Tag type={'ai'} value={'grading'} />
            <Tag type={'ai'} value={'studentFeedback'} />
            <Tag type={'attempts'} value={3} />
            <Tag type={'draft'} value={1} />
            <Tag type={'dueDate'} value={1698906600000} />
            <Tag type={'general'} value={'graded'} />
            <Tag type={'general'} value={'new'} />
            <Tag type={'general'} value={'recommended'} />
            <Tag type={'general'} value={'status'} />
            <Tag type={'general'} value={'suggested'} />
            <Tag type={'general'} value={'trial'} />
            <Tag type={'invitation'} value={'pending'} />
            <Tag type={'invitation'} value={'declined'} />
            <Tag type={'invitation'} value={'expired'} />
            <Tag type={'process'} value={'inProgress'} />
            <Tag type={'rating'} value={'agree'} />
            <Tag type={'rating'} value={'disagree'} />
            <Tag type={'rating'} value={'none'} />
            <Tag type={'role'} value={'instructor'} />
            <Tag type={'submission'} value={'submitted'} />
            <Tag type={'submission'} value={'late'} />
        </>
    );
};

export default TagDemo;
